import MobileNavigation from './mobile-navigation';
import { SideMenu } from './side-menu';
import { NavigationDropdown, SELECTORS as DROPDOWN_SELECTORS } from './dropdown';
import Support from './support';

export default class ShopNavigation {
  initializeEventListeners = () => {
    (new MobileNavigation()).initializeEventListeners();
    (new SideMenu()).initializeEventListeners();
    (new Support()).initializeEventListeners();

    if (document.querySelector(`.${DROPDOWN_SELECTORS.OPTION}`)) {
      (new NavigationDropdown()).initializeEventListeners();
    }
  };
}
